import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import NebulaField from './components/particles/NebulaField';
import RotatingTorus     from "./components/objects/RotatingTorus";

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <ambientLight intensity={0.3} />
        <pointLight position={[0, 0, 5]} intensity={1.2} color="#ffffff" />
        <NebulaField count={4000} />
        <RotatingTorus />
    </CanvasWrapper>
);

export default SplineScene;